import React, { useRef } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Dropdown } from "semantic-ui-react";
import { useSite } from "../../context/siteContext"; // Import the custom hook
import "./siteselection.css";
import "semantic-ui-css/semantic.min.css";
import { useMediaQuery } from "@mui/material";

const SiteSelection = () => {
	const dropdownRef = useRef(null);
	const { selectedSite, updateSite, siteOptions, loading, siteData } = useSite(); // Access context and siteOptions
	const isMobile = useMediaQuery("(max-width: 768px)");
	const handleDivClick = () => {
		if (dropdownRef.current) {
			dropdownRef.current.open(); // Open the dropdown programmatically
		}
	};

	if (loading) {
		return <div>Loading...</div>; // Show a loading indicator while fetching sites
	}

	return (
		<div
			className="site-select"
			onClick={handleDivClick}
			style={{ display: "flex", alignItems: "center", padding: "10px", cursor: "pointer" }}>
			<LocationOnIcon fontSize="large" style={{ marginRight: "8px" }} />
			<div>
				<Dropdown
					ref={dropdownRef}
					className="header-site-dropdown"
					placeholder="Select Site"
					options={siteOptions} // Use the dynamically fetched site options
					value={selectedSite} // Use selected site from context
					onChange={(e, { value }) => updateSite(value, siteData)} // Update context when a site is selected
					search
					direction={!isMobile ? "left" : "right"}
					style={{
						fontWeight: "bold",
						border: "none",
						padding: "0",
						width: "auto",
						color: "#000",
					}}
					margin="none"
				/>
				<div style={{ fontSize: "12px", color: "#000", marginTop: "1px" }}>
					<p>Change Customer</p>
				</div>
			</div>
		</div>
	);
};

export default SiteSelection;
